import { Row, Col, Button, MainModal, Typography, Tabs, Divider } from '../../ui/ot';


const PortalCard = ({
    title = "標題",
    value = "1000",
    unit = "單位",
    cardColor = "#FFEDB5",
    url = "/"
}) => {

    return (
        <Row gutter={[8, 8]}>
            <Col span={24}
                style={{
                    backgroundColor: cardColor,
                    border: '1px solid #ddd',
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                    borderRadius: '0.5rem',  // 這是圓角的設置，數值可以根據需要調整
                    padding: '0.5rem'
                }}>

                <Row
                    style={{
                        display: 'flex',
                        alignItems: 'center',  // 垂直居中對齊
                        justifyContent: 'space-between', // 在水平方向上平均分配空間
                        padding: '1rem'
                    }}>
                    <Col>
                        <Typography.Title level={4} style={{ marginBottom: 0 }}>{title} : {value} {unit}</Typography.Title>
                    </Col>
                    <Col>
                        <Button
                            type="link"
                            style={{ color: '#32518b' }}
                            onClick={() => {
                                window.open(url);
                            }}
                        >
                            查看更多
                        </Button>
                    </Col>
                </Row>
            </Col>
        </Row>
    );
};

export default PortalCard;
